import type { UserFieldsWithViewerIsFollowing } from '@ms/yammer-graphql';

import type { ViewerIsFollowingUser } from '../../../state/types';

export const processViewerIsFollowingUser: (value: UserFieldsWithViewerIsFollowing) => ViewerIsFollowingUser = (
  value
) => ({
  id: value.id,
  isFollowing: value.viewerIsFollowing,
});
